import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-empty-state',
  templateUrl: './empty-state.component.html',
  styleUrl: './empty-state.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EmptyStateComponent {

  // #region Variables
  @Input() image: string = '../../../../assets/img/vendor/no-bill.svg';
  @Input() alt: string = 'empty-state';
  @Input() message: string = 'No data found!';
  
  @Input() showUpload: boolean = false;
  @Input() openForm: boolean = false;
  @Input() buttonLabel: string = 'Upload';
  @Input() buttonIcon: string = 'pi pi-upload';
  @Input() accept: string = '.xlsx,.xls';
  @Input() maxFileSize: number = 10000000;

  @Output() fileSelect = new EventEmitter<any>();
  @Output() openFormEvent = new EventEmitter<string>();
}
